<template>
    <div class="tab-pane fade" id="list-settings-committees" role="tabpanel" aria-labelledby="list-settings-committees-list">
        <div v-if="create_committee_form">
            <h4>
                <div class="row">
                    <div class="col-lg-6" style="align-self: center;">
                        {{ create_committee_form ? "Create Committee" : "All Committees" }}
                    </div>
                    <div class="col-lg-6">
                        <div class="row">
                            <div v-if="create_committee_form" class="col-lg-3 offset-9 py-4 text-right">
                                <button @click="create_committee_form = false" style="float: right;" type="button" class="btn btn-sm btn-danger m-1 text-white btn-raised ripple">
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </h4>
            <div class="main-content mt-0 px-0">
                <div>
                    <v-form @submit.prevent>
                        <div class="container-fluid">
                            <v-row>
                                <v-col cols="12" sm="6" md="6" class="remove-hint">
                                    <span style="color: #111d5e;">Department <i class="fal fa-asterisk" style="font-size: 8px; color: #f00; position: relative; bottom: 5px;"></i></span>
                                    <v-select class="mt-2" :items="departmentName" placeholder="Select department" solo dense :full-width="true" v-model="committee_form.department"></v-select>
                                </v-col>
                                <v-col cols="12" sm="6" md="6" class="remove-hint">
                                    <span style="color: #111d5e;">Committee Name <i class="fal fa-asterisk" style="font-size: 8px; color: #f00; position: relative; bottom: 5px;"></i></span>
                                    <v-text-field v-model="committee_form.committee_name" placeholder="Enter the committee name" solo class="mt-2" dense></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="6" class="remove-hint">
                                    <span style="color: #111d5e;">Committee Description <i class="fal fa-asterisk" style="font-size: 8px; color: #f00; position: relative; bottom: 5px;"></i></span>
                                    <v-text-field v-model="committee_form.description" placeholder="Enter the committee description" solo class="mt-2" dense></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="6" offset-md="3" class="remove-hint">
                                    <button
                                        @click="createCommitteeLoading ? null : create_committee()"
                                        style="width: 99%;"
                                        type="button"
                                        class="btn btn-secondary m-1 text-white btn-raised ripple"
                                    >
                                        {{ createCommitteeText }}
                                        <v-icon
                                            :style="!createCommitteeLoading ? 'display: none;' : 'color: #fff; padding: 0px 10px; font-size: 16px;'"
                                        >
                                            fal fa-circle-notch fa-spin
                                        </v-icon>
                                    </button>
                                </v-col>
                            </v-row>
                        </div>
                    </v-form>
                </div>
            </div>
        </div>
        <div v-else>
            <h4>
                <div class="row">
                    <div class="col-lg-6" style="align-self: center;">
                        Committees Management
                    </div>
                    <div class="col-lg-6" v-if="permissionIsAssigned('department-create')">
                        <div class="row">
                            <div class="col-lg-3 offset-9 py-4">
                                <button @click="create_committee_form = true" style="float: right;" type="button" class="btn btn-sm btn-secondary m-1 text-white btn-raised ripple">
                                    Create Committee
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </h4>
            <div class="table-responsive">
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col" class="text-left">
                                Department
                            </th>
                            <th scope="col" class="text-left">
                                Committee
                            </th>
                            <th scope="col" class="text-left">
                                Description
                            </th>
                            <th
                                v-if="permissionIsAssigned('department-update') || permissionIsAssigned('department-delete')"
                                scope="col"
                                style="width: 10px;"
                            >
                                Actions
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(committee, index) in authCompanyCommittees" :key="'committee-' + index">
                            <td class="text-left">{{ get_dept_name(committee.department_id) }}</td>
                            <td class="text-left">{{ committee.committee_name }}</td>
                            <td class="text-left">{{ committee.description }}</td>
                            <td
                                v-if="permissionIsAssigned('department-update') || permissionIsAssigned('department-delete')"
                                style="padding-top: 13px;"
                                class="employee-options"
                            >
                                <div class="row">
                                    <i
                                        v-if="permissionIsAssigned('department-update')"
                                        @click="launch_edit_committee(committee)"
                                        class="col-3 py-4 text-center fal fa-edit mr-2"
                                        style="color: #069 !important; font-size: 125%; cursor: pointer;"
                                    ></i>
                                    <i
                                        v-if="permissionIsAssigned('department-delete')"
                                        @click="delete_committee(committee)"
                                        class="col-3 py-4 text-center fal fa-trash ml-2"
                                        style="color: #069 !important; font-size: 125%; cursor: pointer;"
                                    ></i>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <v-dialog v-model="committee_edit_dialog" max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="headline">Edit Committee</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-form @submit.prevent>
                            <div class="container-fluid">
                                <v-row>
                                    <v-col cols="12" sm="6" md="6" class="remove-hint">
                                        <span style="color: #111d5e;">Department <i class="fal fa-asterisk" style="font-size: 8px; color: #f00; position: relative; bottom: 5px;"></i></span>
                                        <v-select class="mt-2" :items="departmentName" placeholder="Select department" solo dense :full-width="true" v-model="edit_committee_form.department"></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6" class="remove-hint">
                                        <span style="color: #111d5e;">Committee Name <i class="fal fa-asterisk" style="font-size: 8px; color: #f00; position: relative; bottom: 5px;"></i></span>
                                        <v-text-field v-model="edit_committee_form.committee_name" placeholder="Enter the committee name" solo class="mt-2" dense></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6" class="remove-hint">
                                        <span style="color: #111d5e;">Committee Description <i class="fal fa-asterisk" style="font-size: 8px; color: #f00; position: relative; bottom: 5px;"></i></span>
                                        <v-text-field v-model="edit_committee_form.description" placeholder="Enter the committee description" solo class="mt-2" dense></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6" offset-md="3" class="remove-hint">
                                        <button
                                            @click="edit_committee_submit? null : update_committee()"
                                            style="width: 99%;"
                                            type="button"
                                            class="btn btn-secondary m-1 text-white btn-raised ripple"
                                        >
                                            {{ edit_committee_text }}
                                            <v-icon
                                                :style="!edit_committee_submit ? 'display: none;' : 'color: #fff; padding: 0px 10px; font-size: 16px;'"
                                            >
                                                fal fa-circle-notch fa-spin
                                            </v-icon>
                                        </button>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="committee_edit_dialog = false">
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from "axios";
import { BASE_URL } from "@/main";
import { mapActions, mapGetters } from 'vuex';
export default {
    props: {
        get_dept_name: Function
    },
    data() {
        return {
            create_committee_form: false,
            departmentName: [],
            committee_form: {
                committee_name: "",
                department: "",
                description: "",
            },
            edit_committee_form: {
                id: "",
                committee_name: "",
                department: "",
                description: "",
            },
            createCommitteeText: "Submit",
            createCommitteeLoading: false,
            edit_committee_text: "Update",
            edit_committee_submit: false,
            committee_edit_dialog: false
        }
    },
    computed: {
        ...mapGetters([
            'authCompanyData',
            'authCompanyDepartments',
            'authCompanyCommittees'
        ]),
        committee_department_id() {
            let _this = this;
            if (_this.committee_form.department) {
                return _this.authCompanyDepartments.filter((department) => {
                    return _this.committee_form.department == department.department_name;
                })[0].id;
            } else {
                return "";
            }
        },
        edit_committee_department_id() {
            let _this = this;
            if (_this.edit_committee_form.department) {
                return _this.authCompanyDepartments.filter((department) => {
                    return _this.edit_committee_form.department == department.department_name;
                })[0].id;
            } else {
                return "";
            }
        }
    },
    methods: {
        ...mapActions([
            'fetch_company_committees'
        ]),
        launch_edit_committee(committee) {
            this.edit_committee_form.id = committee.id;
            this.edit_committee_form.committee_name = committee.committee_name;
            this.edit_committee_form.department = this.get_dept_name(committee.department_id);
            this.edit_committee_form.description = committee.description;
            this.committee_edit_dialog = true;
        },
        delete_committee(committee) {
            const _this = this;
            const Toast = _this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 2000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", _this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", _this.$swal.resumeTimer);
                },
            });

            _this.$swal.fire({
                title: "Are you sure you want to delete this committee?",
                showCancelButton: true,
                confirmButtonText: `Yes, Delete`,
            })
            .then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    axios.post(`${BASE_URL}deletecommittee`, {
                        id: committee.id,
                    })
                    .then(function () {
                        Toast.fire({
                            icon: "success",
                            title: "The committee has been deleted successfully",
                        });
                    })
                    .catch(function (error) {
                        Toast.fire({
                            icon: "error",
                            title: "The committee couldn't be deleted",
                        });
                        console.log(error);
                    })
                    .then(function () {
                        _this.fetch_company_committees();
                    });
                }
            });
        },
        update_committee() {
            const _this = this;
            _this.edit_committee_text = "";
            _this.edit_committee_submit = true;
            const Toast = _this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 2000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", _this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", _this.$swal.resumeTimer);
                },
            });
            axios.post(`${BASE_URL}editdepartmentcommittee`, {
                id: _this.edit_committee_form.id,
                committee_name: _this.edit_committee_form.committee_name,
                department_id: _this.edit_committee_department_id,
                description: _this.edit_committee_form.description,
            })
            .then(function () {
                Toast.fire({
                    icon: "success",
                    title: "The committee was updated successfully",
                });
                _this.edit_committee_form.id = "";
                _this.edit_committee_form.committee_name = "";
                _this.edit_committee_form.department = "";
                _this.edit_committee_form.description = "";
                _this.fetch_company_committees();
                _this.committee_edit_dialog = false;
            })
            .catch(function (error) {
                let errors = error.response.data.error || null;
                Toast.fire({
                    icon: "error",
                    title: errors
                        ? typeof errors === "string"
                            ? errors
                            : null || errors.committee_name
                            ? errors.committee_name[0]
                            : null || errors.department_id
                            ? errors.department_id[0]
                            : null || errors.description
                            ? errors.description[0]
                            : null
                        : null || error.response.data.error || error.response.data.message || "The committee could not be updated",
                });
            })
            .then(function () {
                _this.edit_committee_submit = false;
                _this.edit_committee_text = "Update";
            });
        },
        create_committee() {
            const _this = this;
            _this.createCommitteeText = "";
            _this.createCommitteeLoading = true;

            const Toast = _this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 2000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", _this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", _this.$swal.resumeTimer);
                },
            });

            axios.post(`${BASE_URL}createdepartmentcommittee`, {
                company_id: _this.authCompanyData.id,
                committee_name: _this.committee_form.committee_name,
                department_id: _this.committee_department_id,
                description: _this.committee_form.description,
            })
            .then(function () {
                Toast.fire({
                    icon: "success",
                    title: "The committee was added successfully",
                });
                _this.committee_form.committee_name = "";
                _this.committee_form.department = "";
                _this.committee_form.description = "";
                _this.fetch_company_committees();
                _this.create_committee_form = false;
            })
            .catch(function (error) {
                let errors = error.response.data.error || null;
                Toast.fire({
                    icon: "error",
                    title: errors
                        ? typeof errors === "string"
                            ? errors
                            : null || errors.committee_name
                            ? errors.committee_name[0]
                            : null || errors.department_id
                            ? errors.department_id[0]
                            : null || errors.description
                            ? errors.description[0]
                            : null
                        : null || error.response.data.error || error.response.data.message || "The committee could not be added",
                });
            })
            .then(function () {
                _this.createCommitteeLoading = false;
                _this.createCommitteeText = "Submit";
            });
        },

    },
    mounted() {
        const _this = this;
        _this.authCompanyDepartments.forEach((department) => {
            _this.departmentName.push(department.department_name);
        });
    }
}
</script>

<style>

</style>